import { FontFamilyTokenValue } from 'designSystem/types';
import * as S from './styles';

interface FontFamilyTokenPreviewProps {
	value: FontFamilyTokenValue;
}

export const FontFamilyTokenPreview = ({ value }: FontFamilyTokenPreviewProps) => {
	const fontFamily = value.families[0] || 'sans-serif';
	return (
		<S.PreviewContainer>
			<S.FontSample fontFamily={fontFamily}>Aa</S.FontSample>
			<S.ValueText>{value.families.join(', ')}</S.ValueText>
		</S.PreviewContainer>
	);
};
